import { render, staticRenderFns } from "./attnGroupList.vue?vue&type=template&id=3085c714&"
import script from "./attnGroupList.vue?vue&type=script&lang=js&"
export * from "./attnGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports